import { Suspense } from 'react';
import PropTypes from 'prop-types';
import { proc } from '@aexae/js_tools';

import LayoutClockings from '../../components/layouts/LayoutClockings';
import LayoutCometeLink from '../../components/layouts/LayoutCometeLink';
import LoadingScreen from '../../components/loadings/LoadingScreen';
import AuthGuard from '../../guards/AuthGuard';
import RoleBasedGuard from '../../guards/RoleBasedGuard';
import { useAdminBootstrap } from '../../hooks/api/useAdminBootstrap';

export const Loadable = (Component) => {
  return function setLoadable(props) {
    const args = proc.getQueryParams();
    return (
      <Suspense fallback={<LoadingScreen />}>
        <Component {...props} args={args} />
      </Suspense>
    );
  };
};

// Doit être au-dessus de RoleBasedGuard : ce dernier attend isReady du store
// de permissions, que seul useAdminBootstrap remplit. Placé dans le layout,
// un refresh sur une route à requiredPermissions deadlock (guard=null → layout
// jamais monté → bootstrap jamais appelé → isReady jamais true → page blanche).
const AdminBootstrap = ({ children }) => {
  useAdminBootstrap();
  return children;
};
AdminBootstrap.propTypes = {
  children: PropTypes.node
};

export const Elements = ({ accessibleRoles, requiredUserProps, requiredPermissions, isClockingApp }) => (
  <AuthGuard>
    <AdminBootstrap>
      <RoleBasedGuard accessibleRoles={accessibleRoles} requiredUserProps={requiredUserProps} requiredPermissions={requiredPermissions}>
        {isClockingApp ? <LayoutClockings /> : <LayoutCometeLink />}
      </RoleBasedGuard>
    </AdminBootstrap>
  </AuthGuard>
);
Elements.propTypes = {
  accessibleRoles: PropTypes.array,
  requiredUserProps: PropTypes.arrayOf(PropTypes.string),
  requiredPermissions: PropTypes.arrayOf(PropTypes.string),
  isClockingApp: PropTypes.bool
};
